export const DEFAULT_ACTION = '/IndusindMinKyc/DEFAULT_ACTION';
export const SET_INDUSIND_MIN_KYC_CITIES_SUCCESS = '/IndusindMinKyc/SET_INDUSIND_MIN_KYC_CITIES_SUCCESS';
export const SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS = '/IndusindMinKyc/SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS';
export const SET_INDUSIND_MIN_KYC_USER_UPDATE_SUCCESS = '/IndusindMinKyc/SET_INDUSIND_MIN_KYC_USER_UPDATE_SUCCESS';
export const LAST_NAME_TOOLTIP_INFO = 'In Case You do not have a Last Name, Please Enter the First Name as the Last Name';
export const SET_INDUSIND_MIN_KYC_USER_DETAILS_SUCCESS = '/IndusindMinKyc/SET_INDUSIND_MIN_KYC_USER_DETAILS_SUCCESS';
export const SET_DEDUPE_VERIFY_SUCCESS = '/IndusindMinKyc/SET_DEDUPE_VERIFY_SUCCESS';

export const consentText = Object.freeze({
  ConsentTextIndusInd: `
      I hereby declare that the details and information given above are complete and true to the best of my knowledge.`,
});



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/constants.js